import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
const Wrapper = styled.div ``;
export const IconSignal = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            const leftGroup = wrapperRef.current?.querySelectorAll('g g:first-child path');
            const rightGroup = wrapperRef.current?.querySelectorAll('g g:last-child path');
            if (leftGroup && rightGroup) {
                gsap.to(leftGroup, {
                    keyframes: [
                        {
                            x: -2,
                            opacity: 0,
                            duration: 0.1,
                            stagger: 0.075,
                            clearProps: 'x',
                        },
                        {
                            delay: 0.1,
                            opacity: 1,
                            duration: 0.2,
                            stagger: -0.1,
                        },
                    ],
                });
                gsap.to(rightGroup, {
                    keyframes: [
                        {
                            x: 2,
                            opacity: 0,
                            duration: 0.1,
                            stagger: 0.075,
                            clearProps: 'x',
                        },
                        {
                            delay: 0.1,
                            opacity: 1,
                            duration: 0.2,
                            stagger: -0.1,
                        },
                    ],
                });
            }
            triggerDone();
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Icon.Signal, null)));
};
//# sourceMappingURL=Signal.js.map